module.exports = __webpack_public_path__ + "src/routes/aboutus/BANNER .png?76b23ec9";


//////////////////
// WEBPACK FOOTER
// ./src/routes/aboutus/BANNER .png
// module id = 2827
// module chunks = 1